// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/unserneuere-transporteristda-2/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const unserneuereTransporteristda2DE: PageEntry = {
  id: "post.unserneuere-transporteristda-2",
  locale: "de",
  slug: "unserneuere-transporteristda-2",
  seo: {
    title: "Erasmus-Projekt | Dietz GmbH",
    description: "Erasmus-Projekt",
  },
  type: "post",
  h1: "Erasmus-Projekt",
  blocks: [
    { kind: "heading", level: 2, text: "Erasmus-Projekt" },
    { kind: "paragraph", text: "Unsere Azubis Pascal und Nico grüßen ganz herzlich aus Belgien. Im Rahmen des „Erasmus+“-Programms der Europäischen Union haben die beiden Durchstarter die Möglichkeit bekommen, für einige Zeit in ein anderes Unternehmen hineinzuschnuppern: in diesem Fall ist das Samsonite in Belgien." }
  ],
};
